export default __webpack_public_path__ + "98300640cbfc65b95d2e641c59a64061.svg";